module.exports = __webpack_public_path__ + "img/11dimensionality.fc0777c3.png";